import { GET_ALL_ITEMS, GET_ALL_MARKET_CATEGORIES, GET_ALL_ITEM_CATEGORIES, GET_ALL_ITEM_GROUPS, GET_ITEM_SCHEDULE_DATA, GET_SINGLE_ITEM, UPDATE_ITEM_ADDON, ADD_ITEM_ADDON, DELETE_ITEM_ADDON } from "./actionType";

const initialState = {
    item_categories: [],
    market_categories: [],
    item_groups: [],
    items: [],
    single_item: '',
    schedule_data: [],
    item_addon: [],
};

export default function (state = initialState, action) {
    switch (action.type) {
        case GET_ALL_ITEM_CATEGORIES:
            return { ...state, item_categories: action.payload };
        case GET_ALL_MARKET_CATEGORIES:
            return { ...state, market_categories: action.payload };
        case GET_ALL_ITEMS:
            return { ...state, items: action.payload };
        case GET_ITEM_SCHEDULE_DATA:
            return { ...state, schedule_data: action.payload };
        case GET_SINGLE_ITEM:
            return { ...state, single_item: action.payload };
        case GET_ALL_ITEM_GROUPS:
            return { ...state, item_groups: action.payload };
        case ADD_ITEM_ADDON:
            return { ...state, item_addon: action.payload };
        case UPDATE_ITEM_ADDON:
            return { ...state, item_addon: action.payload };
        case DELETE_ITEM_ADDON:
            return { ...state, item_addon: action.payload };
        default:
            return state;
    }
}
